import { render, staticRenderFns } from "./AutomatedTasksUpdateDoc.vue?vue&type=template&id=0fdb55c9"
import script from "./AutomatedTasksUpdateDoc.vue?vue&type=script&lang=js"
export * from "./AutomatedTasksUpdateDoc.vue?vue&type=script&lang=js"
import style0 from "./AutomatedTasksUpdateDoc.vue?vue&type=style&index=0&id=0fdb55c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports